import { bundleConfig } from '../../config';
import { PriceTier, serializePriceTier } from '../../../models/PriceTier';
import { http } from '../axios';

export type FetchBundleTotalsApiResponse = {
    readonly basePrice?: number;
    readonly netValue?: number;
    readonly currency?: string;
    readonly savedValue?: number;
    readonly savedPercentage?: number;
};

export type FetchBundleTotalsParams = {
    readonly bundleId: string;
    readonly priceTier: PriceTier;
};

const { endpointBundleTotals } = bundleConfig();

export const fetchBundleDetailTotals = ({
    bundleId,
    priceTier
}: FetchBundleTotalsParams): Promise<FetchBundleTotalsApiResponse> => {
    return http
        .get<FetchBundleTotalsApiResponse>(endpointBundleTotals, {
            params: { 'price-tier': serializePriceTier(priceTier) },
            pathParams: { bundleId }
        })
        .then(response => response.data);
};
